// src/comps/LoginPage.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_URL } from "../config";

const LoginPage = () => {
  const [email, setEmail] = useState(""); // now using email as identifier
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.msg || "Login failed");
      } else {
        // Store token (e.g., in localStorage)
        localStorage.setItem("token", data.token);
        navigate("/community");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred");
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <h1 className="text-4xl font-bold mb-6">Login</h1>
      <form onSubmit={handleLogin} className="bg-white p-8 rounded shadow-md w-80">
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <div className="mb-4">
          <label className="block text-black mb-2" htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            className="border w-full p-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-black mb-2" htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            className="border w-full p-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="bg-[#800000] text-white py-2 px-4 rounded w-full hover:bg-[#9b0000] transition">
          Login
        </button>
      </form>
      <p className="mt-4">
        New member?{" "}
        <Link to="/create-account" className="text-[#800000] font-bold hover:underline">
          Create an account
        </Link>
      </p>
    </div>
  );
};

export default LoginPage;
